type MillisecondsProps = {
  days?: number
  hours?: number
  minutes?: number
  seconds?: number
}

export function Milliseconds({
  days,
  hours,
  minutes,
  seconds,
}: MillisecondsProps) {
  let milli = 0

  if (days) milli += days * 24 * 60 * 60 * 1000
  if (hours) milli += hours * 60 * 60 * 1000
  if (minutes) milli += minutes * 60 * 1000
  if (seconds) milli += seconds * 1000

  return milli
}
